export default __webpack_public_path__ + "static/b-corp-4bc6220578499739e10362014ea6bb1e.svg";